import { render, staticRenderFns } from "./ResendMessageButton.vue?vue&type=template&id=4b4d1c44&scoped=true&"
import script from "./ResendMessageButton.vue?vue&type=script&lang=js&"
export * from "./ResendMessageButton.vue?vue&type=script&lang=js&"
import style0 from "./ResendMessageButton.vue?vue&type=style&index=0&id=4b4d1c44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4d1c44",
  null
  
)

export default component.exports